import React from 'react';

class Error extends React.Component {
    render() {
        return (
            <div className="error">
                <img src={require("../images/error.svg")} alt="Error!" />
                <p>{this.props.error}</p>
            </div>
        )
    }
}

export default Error;